import { getYearMonthDay } from './mini-events/get-stay-field';

import type { Culture as AppCulture } from '@shared/types/context';
import type { Stay } from '@shared/types/utils';
import type {
  SkyscannerCommonV1Datetime,
  SkyscannerCultureCommonV1,
  SkyscannerHotelCommonV1HotelContext,
  SkyscannerHotelCommonV1HotelStay,
  SkyscannerSavedexperienceapiV2Service,
} from '@skyscanner-internal/saved-experience-api-web-http-client';

// Re-export types from the saved-experience-api package
export type LocalDate = SkyscannerCommonV1Datetime.LocalDate;
export type HotelContext = SkyscannerHotelCommonV1HotelContext.HotelContext;
export type GuestGroup = SkyscannerHotelCommonV1HotelContext.GuestGroup;
export type ChildrenAge = SkyscannerHotelCommonV1HotelContext.ChildrenAge;
export type Culture = SkyscannerCultureCommonV1.Culture;
export type HotelStay = SkyscannerHotelCommonV1HotelStay.HotelStay;
export type SaveItemRequest =
  SkyscannerSavedexperienceapiV2Service.SaveItemRequest;

const createChildrenAges = (childrenAges: number[]): ChildrenAge[] =>
  childrenAges.map((age) => ({ age: Number(age) }));

const createGuestGroup = (
  numberOfAdults: number,
  childrenAges: number[],
): GuestGroup => ({
  adultCount: numberOfAdults,
  childrenAges: createChildrenAges(childrenAges),
});

export const createHotelContext = (
  stay: Stay,
  destinationEntityId?: string,
): HotelContext => {
  const { checkIn, checkOut, childrenAges, numberOfAdults, numberOfRooms } =
    stay;

  return {
    destinationEntityId,
    checkinDate: getYearMonthDay(checkIn),
    checkoutDate: getYearMonthDay(checkOut),
    guestGroup: createGuestGroup(numberOfAdults, childrenAges),
    roomCount: numberOfRooms,
  };
};

export const createHotelStay = (
  hotelId: string,
  stay: Stay,
  destinationEntityId?: string,
): HotelStay => ({
  hotelId,
  hotelContext: createHotelContext(stay, destinationEntityId),
});

export const createCulture = (culture: AppCulture): Culture => ({
  locale: culture.locale,
  market: culture.market,
  currencyCode: culture.currency,
});

export const createHotelSaveItemRequest = (
  hotelStay: HotelStay,
  cultureSettings: Culture,
  actionId: string,
): SaveItemRequest => ({
  actionId,
  cultureSettings,
  hotelStay,
});
